/* eslint-disable */
import React, { useState, useEffect } from "react";
import Select from "react-select";

/*import url and gateway methods */
import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { useTranslation } from "react-i18next";
import { reactSelectStyle } from "Config/Config";

const AddToListModal = ({
  moduleName,
  selectedIds,
  afterModalClose,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const token = localStorage.getItem("token");
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const [allList, setAllList] = useState([]);
  const [listValue, setlistValue] = useState(null);
  const [selectedListId, setselectedListId] = useState(null);
  const [isAdding, setIsAdding] = useState(false);

  //get all lsit
  const getAllList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_LIST + `?token=${token}`;

      // console.log(requestUrl);
      if (moduleName === "contact") {
        requestUrl += `&typeslug=TYPE_CONTACT`;
      } else if (moduleName === "company") {
        requestUrl += `&typeslug=TYPE_COMPANY`;
      } else if (moduleName === "lead") {
        requestUrl += `&typeslug=TYPE_LEAD`;
      } else {
      }

      const response = await getData(requestUrl);

      // console.log("response ------>", response);

      if (response.status) {
        setAllList(
          response.data.map((typeData) => ({
            label: typeData.title,
            value: typeData._id,
          }))
        );
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //select list
  const listSelectionHandler = (val) => {
    if (val) {
      setlistValue(val);
      setselectedListId(val.value);
    } else {
      setlistValue(null);
      setselectedListId(null);
    }
  };

  //add to list function
  const addToListHandler = async () => {
    if (selectedListId && selectedIds.length > 0) {
      try {
        setIsAdding(true);
        let listData = {};

        let requestUrl =
          url.API_BASE_URL +
          url.API_UPDATE_A_LIST +
          `/${selectedListId}` +
          `?token=${token}&modulename=${moduleName}`;

        if (moduleName === "contact") {
          listData.contactids = selectedIds;
        } else if (moduleName === "company") {
          listData.companyids = selectedIds;
        } else if (moduleName === "lead") {
          listData.leadids = selectedIds;
        } else {
        }

        console.log("listData ------>", listData);

        const response = await putData(requestUrl, listData);

        console.log("response ------>", response);

        setIsAdding(false);

        if (response.status) {
          resetHandler();
          setMessageType("success");
          // close the modal of addLabel
          let listModal = document.querySelector("#addToList");
          let modal = bootstrap.Modal.getInstance(listModal);
          modal.hide();

          afterModalClose();
        } else {
          setMessageType("error");
        }
        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select lead from lead list");
      setMessageType("error");
    }

    setShowAlert(true);
  };

  const resetHandler = () => {
    setlistValue(null);
    setselectedListId(null);
  };

  useEffect(() => {
    getAllList();
  }, []);

  return (
    <div
      className="modal fade"
      id="addToList"
      tabIndex="-1"
      aria-labelledby="addToListLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary icon-md">
                  add
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-4 text-white mb-0"
                  id="addToListLabel"
                >
                  {t("Add to List")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Choose a list to associate items with")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
              {isAdding && (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white bg-opacity-75"
                  style={{ zIndex: 1050 }}
                >
                  <div
                    className="spinner-border text-primary mb-3"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="text-primary fw-semibold mb-0">
                    Adding to list, please wait...
                  </p>
                </div>
              )}
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                <div className="fields-container flex-fill">
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="selectList"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Select Target List")}
                    </label>
                    <Select
                      isClearable
                      placeholder="Search or select a list"
                      options={allList}
                      value={listValue}
                      onChange={(val) => listSelectionHandler(val)}
                      styles={reactSelectStyle("3px", "6px", true, false)}
                    />
                  </div>
                </div>
                <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={addToListHandler}
                    style={{ cursor: isAdding ? "not-allowed" : "pointer" }}
                    disabled={isAdding ? true : false}
                  >
                    {isAdding ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {t("Adding...")}
                      </>
                    ) : (
                      <>
                        <span className="material-symbols-outlined me-1">
                          add
                        </span>
                        {t("Add To List")}
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddToListModal;
